import { render, staticRenderFns } from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=template&id=38fa95de&scoped=true&"
import script from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=script&lang=js&"
export * from "./ExportationFrameWalkingChartPronationAngles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa95de",
  null
  
)

export default component.exports